<!-- 移動元: unsubscribed/Confirm.vue または subscribed/Confirm.vue の内容をここに移動 -->
<!-- ここに共通の確認画面の実装を記述してください -->
<template>
  <v-container>
    <v-card class="pa-8 mx-auto" max-width="900">
      <!-- タイトル -->
      <v-row class="mb-6">
        <v-col class="text-center">
          <h2 class="text-h5 font-weight-bold mb-2">
            申込内容の確認
          </h2>
        </v-col>
      </v-row>
      <!-- サブタイトル -->
      <v-row class="mb-6">
        <v-col>
          <h4 class="text-subtitle-1">
            入力内容をご確認ください
          </h4>
        </v-col>
      </v-row>
      <!-- 確認内容表示 -->
      <v-row class="mb-4">
        <v-col cols="12">
          <edi-confirm-table :form-data="formData" />
        </v-col>
      </v-row>
      <v-divider class="my-6" />
      <!-- 利用規約 -->
      <v-row v-if="isNew" class="mb-6">
        <v-col cols="12">
          <p class="text-center font-weight-bold mb-4">
            JWNET-EDI連携サービス利用規約
          </p>
          <v-card outlined class="pa-4 mb-4 terms-scroll-area">
            <v-card-text>
              <!-- 利用規約 -->
              <vue-editor
                v-model="formData.terms_of_edi_request"
                :disabled="true"
                class="custom-quill-container"
              />
              <!-- /利用規約 -->
            </v-card-text>
          </v-card>
          <v-checkbox
            v-model="agreed"
            hide-details
          >
            <template v-slot:label>
              <span class="text-body-2">
                利用規約に同意し、上記の内容で申し込みます
              </span>
            </template>
          </v-checkbox>
        </v-col>
      </v-row>
      <!-- フッターボタン -->
      <v-row class="mt-8">
        <v-col cols="6">
          <v-btn
            block
            large
            outlined
            @click="goBack"
          >
            戻る
          </v-btn>
        </v-col>
        <v-col cols="6">
          <v-btn
            block
            large
            color="primary"
            :disabled="isNew && !agreed"
            @click="submit"
          >
            申込を実行
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import EdiConfirmTable from '@/components/EdiConfirmTable'

export default {
  name: 'RegistrationConfirm',
  components: {
    EdiConfirmTable,
  },
  props: {
    formData: {
      type: Object,
      required: true
    },
    isNew: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      agreed: false,
    }
  },
  methods: {
    goBack() {
      this.$emit('goBack')
    },
    async submit() {
      if (this.isNew && !this.agreed) {
        return
      }
      this.$emit('submit')
    }
  }
}
</script>

<style scoped lang="scss">
.terms-scroll-area {
  max-height: 200px;
  overflow-y: auto;
}

.custom-quill-container {
  /deep/ {
    .ql-toolbar {
      display: none;
    }
    .ql-container {
      height: auto !important;
      overflow: visible;
    }
    .ql-editor {
      max-height: none;
      overflow: visible;
      padding: 0;
    }
    .ql-snow {
      border: none !important;
    }
  }
}
</style>
